<template>         
      <el-scrollbar style="background-color:rgb(60,65,76);font-family:'syht'; "> 
          <div class="bg">
              <div :style="{'height':FirstHeight}"
              style="margin-left: 10%;width: 80%;padding-top:80px;">
              </div>
              <div class="big3">
                  <div class="bg-title">政务信息</div>
                  <div class="bg-top"></div>
                  <div style="height: 60px;margin:-10px 30px 20px 30px;" v-if="companyShow">
                 <img :src="detailResult.ImageUrl" style="float:left;width: 50px;height: 50px;">
                 <div style="float: left;margin-left: 20px;font-size: 18px;height:50px;line-height:50px;">{{detailResult.Name}}</div> 
                 </div>
                 <div class="bg-content">
                   <table class="bg-table" border="1" bordercolor="#4e717d">
                    <template v-if="companyShow">
                    <tr>
                        <td class="title">登记机关</td>
                        <td>{{detailResult.BelongOrg}}</td>
                        <td class="title">法定代表人名</td>
                        <td style="color:yellow ">{{detailResult.OperName}}</td>
                    </tr>
                    <tr>
                        <td class="title">成立日期</td>
                        <td>{{detailResult.StartDate}}</td>
                        <td class="title">企业状态</td>
                        <td>{{detailResult.Status}}</td>
                    </tr>
                    
                 <tr v-if="RevokeInfoShow">
                        <td class="title">注销日期</td>
                        <td >{{detailResult.RevokeInfo.CancelDate}}</td>
                        <td class="title">注销原因</td>
                        <td>{{detailResult.RevokeInfo.CancelReason}}</td>
                    </tr>
                    <tr v-if="RevokeInfoShow2">
                        <td class="title">吊销日期</td>
                        <td>{{detailResult.RevokeInfo.RevokeDate}}</td>
                        <td class="title">吊销原因</td>
                        <td>{{detailResult.RevokeInfo.RevokeReason}}</td>
                    </tr>
                    <tr>
                        <td class="title">注册资本</td>
                        <td>{{detailResult.RegistCapi}}</td>
                        <td class="title">实缴资本</td>
                        <td>{{detailResult.RecCap}}</td>
                    </tr>
                    <tr>
                        <td class="title">企业类型</td>
                        <td>{{detailResult.EconKind}}</td>
                        <td class="title">注册号</td>
                        <td>{{detailResult.No}}</td>
                    </tr>
                    <tr>
                        <td class="title">地址</td>
                        <td colspan="3">{{detailResult.Address}}</td>
                    </tr>
                    <tr>
                        <td class="title">经营范围</td>
                        <td colspan="3">{{detailResult.Scope}}</td>
                    </tr>
                  </template>
                    <tr v-if="personShow">
                        <td class="title">姓名</td>
                        <td>{{ myName }}</td>
                        <td class="title">身份证号</td>
                        <td>{{ idCard }}</td>
                    </tr>
                    <tr>
                        <td class="title">婚姻信息</td>
                        <td>{{ credit.HYXX }}</td>
                        <td class="title">户籍信息</td>
                        <td>{{ credit.HJXX }}</td>
                    </tr>
                    <tr>
                        <td class="title">社保信息</td>
                        <td style="width:36%">{{ credit.SBXX }}</td>
                        <td class="title">公积金信息</td>
                        <td>{{ credit.GJJXX }}</td>
                    </tr>
                    <tr  v-if="companyShow">
                        <td class="title" >失信被执行数量</td>
                        <td v-if="caseResult[0]>0" 
                          style="cursor: pointer;color: red" @click="queryClick(0)">
                          {{caseResult[0]}}</td>
                        <td v-else>0</td>
                        <td class="title">被执行数量</td>
                        <td v-if="caseResult[1]>0" 
                          style="cursor: pointer;color: red" @click="queryClick(1)">
                          {{caseResult[1]}}</td>
                        <td v-else>0</td>
                      </tr>
                       <tr  v-if="companyShow">
                        <td class="title">严重违法数量</td>
                        <td v-if="caseResult[2]>0" 
                          style="cursor: pointer;color: red" @click="queryClick(2)">
                          {{caseResult[2]}}</td>
                        <td v-else>0</td>
                        <td class="title">裁判文书数量</td>
                        <td v-if="caseResult[3]>0" 
                          style="cursor: pointer;color: red" @click="queryClick(3)">
                          {{caseResult[3]}}</td>
                        <td v-else>0</td>
                    </tr>
                  </table>
                 </div>
              </div>
              <div class="bg-bottom" v-if="dataShow"></div>
              <div v-if="dataShow"  :class="getlenClass(sxdataList.length)">
                  <!-- <div style="text-align: center;font-weight: bold;margin-bottom: 10px;">---{{labelList[sxtype]}}信息---</div> -->
                  <div class="bg-title">{{labelList[sxtype]}}信息</div>
                  <div class="bg-top"></div>
                  <div  class="bg-content" >
                      <table v-if="sxtype==3" class="bg-table" border="1" bordercolor="#4e717d">
                    <tr style="font-weight: bold;">
                        <td style="width:20%">案号</td>
                        <td style="width:20%">案由</td>
                        <td style="width:15%">发布日期</td>
                        <td style="width:15%">金额（元）</td>
                        <td style="width:15%">角色</td>
                        <td style="width:15%">案件声明</td>
                    </tr>
                    <tr v-for="(abc,i) in sxdataList">
                            <td>{{abc.CaseNo}}</td>
                            <td>{{abc.CaseReason}}</td>
                            <td>{{abc.PublishDate}}</td>
                            <td>{{abc.Amount}}</td>
                            <td>{{abc.RoleType}}</td>
                              <td>{{abc.Statement}}</td>
                        </tr>
                   </table> 
                   <table v-if="sxtype==2" class="bg-table" border="1" bordercolor="#4e717d">
                    <tr style="font-weight: bold;">
                        <td style="width:40%">列入原因</td>
                        <td style="width:30%">列入决定机关</td>
                        <td style="width:15%">列入时间</td>
                        <td style="width:15%">移除时间</td>
                    </tr>
                    <tr v-for="(abc,i) in sxdataList">
                            <td>{{abc.AddReason}}</td>
                            <td>{{abc.AddOffice}}</td>
                            <td>{{abc.AddDate}}</td>
                            <td>{{abc.RemoveDate}}</td>
                        </tr>
                   </table> 
                   <table v-if="sxtype==1" class="bg-table" border="1" bordercolor="#4e717d">
                    <tr style="font-weight: bold;">
                        <td style="width:20%">案号</td>
                        <td style="width:20%">立案时间</td>
                        <td style="width:20%">执行法院</td>
                        <td style="width:20%">执行标的（元）</td>
                        <td style="width:20%">疑似申请执行人</td>
                    </tr>
                    <tr v-for="(abc,i) in sxdataList">
                            <td>{{abc.Anno}}</td>
                            <td>{{abc.Liandate}}</td>
                            <td>{{abc.JudgeDate}}</td>
                            <td>{{abc.Biaodi}}</td>
                            <td>{{abc.SuspectedApplicant}}</td>
                        </tr>
                   </table> 
                   <table v-if="sxtype==0" class="bg-table" border="1" bordercolor="#4e717d">
                    <tr style="font-weight: bold;">
                        <td style="width:20%">案号</td>
                        <td style="width:15%">履行情况</td>
                        <td style="width:15%">发布日期</td>
                        <td style="width:15%">金额（元）</td>
                        <td style="width:35%">失信行为</td>
                    </tr>
                    <tr v-for="(abc,i) in sxdataList">
                            <td>{{abc.Anno}}</td>
                            <td>{{abc.Executestatus}}</td>
                            <td>{{abc.Publicdate}}</td>
                            <td>{{abc.Amount}}</td>
                            <td>{{abc.ActionRemark}}</td>
                        </tr>
                   </table> 
                   <div v-if="mlShow" style=" margin: 10px 40% 4px 40%;width: 20%;">
                     <div @click="getList(-1)"
                     style="cursor: pointer;width:40%;float: left;" >上一页</div>
                     <div style="width:20%;float: left;">{{ pageIndex }}</div> 
                     <div  @click="getList(1)"
                     style="cursor: pointer;width:40%;float: left;">下一页</div>
                   </div>
                   </div>


                 </div>


                 <div class="bg-bottom"></div>
                <div :class="getlenClass(llTableData.length)">
                  <div class="bg-title">农业信息</div>
                   <div class="bg-top"></div>
                   <div v-if="llTableData.length==0&&credit.area=='暂无'"  class="bg-content-text">
                            暂无信息
                   </div>
                   <div class="bg-content" v-else>
                      <table class="bg-table" border="1" bordercolor="#4e717d">
                      <template v-if="llTableData.length>0">
                      <tr style="font-weight: bold;">
                        <td colspan="4">权证流水号</td>
                        <td colspan="4">发包方名称</td>
                        <td colspan="4">承包方期限</td>
                        <td colspan="2">承包方名称</td>
                        <td colspan="2">地块面积</td>
                        <td colspan="2">地块总数</td>
                        <td colspan="3">土地类型</td>
                        <td colspan="3">土地用途</td>
                        
                    </tr>
                    <tr v-for="(abc,i) in llTableData">
                            <td colspan="4">{{abc.QZLSH}}</td>
                            <td colspan="4">{{abc.FBFMC}}</td>
                            <td colspan="4">{{abc.CBQXQ}}至{{abc.CBQXZ}}</td>
                            <td colspan="2">{{abc.name}}</td>
                            <td colspan="2">{{abc.area}}</td>
                            <td colspan="2">{{abc.num}}</td>
                            <td colspan="3">{{abc.TDLYLX}}</td>
                            <td colspan="3">{{abc.TDYT}}</td>
                        </tr>
                      </template>
                      <tr v-if="credit.area!='暂无'">
                        <td class="title" colspan="4">土地流转</td>
                        <td colspan="24">{{ credit.area }}</td>
                    </tr>
                      </table> 
                   </div>
              </div>
              <div class="bg-bottom"></div>
              <div :class="getlenClass(zxbglist.length)">
                  <div class="bg-title">人行征信</div>
                   <div class="bg-top"></div>
                   <div v-if="zxbglist.length==0"  class="bg-content-text">
                            暂无信息
                   </div>
                   <div class="bg-content" v-else>
                      <table class="bg-table" border="1" bordercolor="#4e717d">
                        <tr style="font-weight: bold;">
                        <td colspan="4">贷款银行</td>
                        <td colspan="2">贷款余额（万元）</td>
                        <td colspan="2">担保方式</td>
                        <td colspan="2">是否逾期</td>
                        <td colspan="2">逾期期限 </td>
                        <td colspan="2">逾期金额 </td>
                    </tr>
                    <tr v-for="(abc,i) in zxbglist">
                            <td colspan="4">{{abc.name}}</td>
                            <td colspan="2">{{abc.money}}</td>
                            <td colspan="2">{{abc.bzfs}}</td>
                            <td colspan="2">{{islatelist[abc.islate]}}</td>
                            <td colspan="2">{{abc.month}}</td>
                            <td colspan="2">{{abc.lateMoney}}</td>
                        </tr>
                      </table> 
                   </div>
              </div>
              <div class="bg-bottom"></div>
                 <div class="small">
                    <div class="bg-title">村镇干部评价</div>
                    <div class="bg-top"></div>
                    <!-- <div class="bg-content-text">
                             {{credit.comment2}}
                    </div> -->
                    <div class="bg-content">
                      <table class="bg-table" border="1" bordercolor="#4e717d">
                        <tr>
                          <td class="title" >积分制积分</td>
                          <td>{{credit.comment2_jfzjf}}</td>
                        </tr>
                        <tr>
                          <td class="title" >规模</td>
                          <td>{{credit.comment2_gm}}</td>
                        </tr>
                        <tr>
                          <td class="title" >技术</td>
                          <td>{{credit.comment2_js}}</td>
                        </tr>
                        <tr>
                          <td class="title" >效益</td>
                          <td>{{credit.comment2_xy}}</td>
                        </tr>
                        <tr>
                          <td class="title" >综合信誉</td>
                          <td>{{credit.comment2}}</td>
                        </tr>
                      </table> 
                    </div>
              </div>
              <div class="bg-bottom"></div>
              <div class="small">
                  <div class="bg-title">同行评价</div>
                   <div class="bg-top"></div>
                   <!-- <div class="bg-content-text">
                            {{credit.comment}}
                   </div> -->
                   <div class="bg-content">
                      <table class="bg-table" border="1" bordercolor="#4e717d">
                        <tr>
                          <td class="title" >规模</td>
                          <td>{{credit.comment_gm}}</td>
                        </tr>
                        <tr>
                          <td class="title" >技术</td>
                          <td>{{credit.comment_js}}</td>
                        </tr>
                        <tr>
                          <td class="title" >效益</td>
                          <td>{{credit.comment_xy}}</td>
                        </tr>
                        <tr>
                          <td class="title" >综合信誉</td>
                          <td>{{credit.comment}}</td>
                        </tr>
                      </table> 
                    </div>
              </div>
              <div class="bg-bottom"></div>
              <div class="small">
                  <div class="bg-title">预授信</div>
                   <div class="bg-top"></div>
                   <div class="bg-content" >
                      <table class="bg-table" border="1" bordercolor="#4e717d">
                        <tr>
                          <td  class="title ">综合评分</td>
                          <td class="atext"  style="width: 36%;">{{credit.score}}</td>
                        <td class="title "   >预授信</td>
                        <td class="atext" style="width: 36%;">{{credit.PreCredit=="暂无"?area_PreCredit:credit.PreCredit+'万元'}}</td>
                      </tr>
                      </table> 
                   </div>
              </div>
              <div class="bg-bottom"></div>
              <div style="height: 70px;margin-left: 10%;width: 80%;">
              </div>
          </div>
      </el-scrollbar>
</template>

<script>
import { t } from "element-plus/lib/locale";
import qccapis  from "../api/qcc";
export default {
    data() {
        return {
          searchType:1,
            idCard:"",
            Code:"",
            dataList:[],
            detailDialogShow:false,
            companyShow:false,
            detailResult:{},
            RevokeInfoShow:false,
            RevokeInfoShow2:false,
            personShow:false,
            caseResult:["","","",""],
            llListResult:[],
            cllListResult:[],
            cllTableData:[],
            zxbglist:[],
            dataShow:false,
            sxdataList:[],
            sxdata:[],
            sxtype:0,
            labelList:["失信被执行","被执行","严重违法","裁判文书"],
            credit:{num:"暂无",comment:"暂无"},
            AllData:[[],[],[],[]],
            pageIndex:1,
            pageSize:10,
            mlShow:false,
            llTableData:[],
            FirstHeight:'70px',
            bzfslist:["","信用","保证","抵押","组合"],
            islatelist:["否","是"],
            area_PreCredit:"暂无"
        };
      },
      mounted() {
        let that = this;
        that.calcTableHeight();
        // 注：window.onresize只能在项目内触发1次
        window.onresize = function windowResize() {
            that.calcTableHeight();
         }
       },
        created() {
            this.idCard=this.$route.query.idCard;
            this.Code=this.$route.query.code;
            this.myName=this.$route.query.keyword;
            var that=this;
            if(this.Code){
              this.companyShow=true;
               let param1 = {
                    id:this.Code
                 }
                qccapis.getCPDetail(param1).then(res => {
                 if(res!=null){
                  if(Number(res.Status)==200){
                  that.detailResult = res.Result;
                  var revoke=res.Result.RevokeInfo;
                  if(revoke!=null){
                    if(revoke.CancelDate) that.RevokeInfoShow=true 
                    if(revoke.RevokeDate) that.RevokeInfoShow2=true 
                  };
                   }else{
                    that.$message.error("查询信息出错")
                    }
                  }else{
                   that.$message.error("查询信息失败")
                  }
                });
                that.getCPCase(this.Code);
               
             }else {
              this.personShow=true;
             };
           var param2={
               idCard:this.idCard,
               code:this.Code
           }
               qccapis.getCredit(param2).then(res => {
                   if(res!=null){
                        that.credit=res;
                        if(res.zxbgList){
                          that.zxbglist = JSON.parse(res.zxbgList)
                        }
                        if(res.myName)that.myName=res.myName;
                        that.llTableData=res.list;
                        if(that.llTableData&&that.llTableData.length>0){
                          var age=that.getAge(that.idCard);
                          if(age>17&&age<60){
                            var n=0;
                          for(var i=0;i<that.llTableData.length;i++){
                           n+=Number(that.llTableData[i].area)
                          }
                          if(n==0)that.area_PreCredit=5;
                          else if(n>=20)that.area_PreCredit=20;
                          else if(n>=10)that.area_PreCredit=10;
                          else that.area_PreCredit=8;
                          }
                        }else{
                          that.llTableData=[]
                        }
                   }
             });
             
            //   qccapis.getLL({idCard:this.idCard}).then(res => {
            //        if(res!=null){
            //             that.llTableData=res.list;
            //             if(this.llTableData.length>0){
            //               var age=that.getAge(this.idCard);
            //               if(age>17&&age<60){
            //                 var n=0;
            //               for(var i=0;i<that.llTableData.length;i++){
            //                n+=Number(that.llTableData[i].area)
            //               }
            //               if(n==0)that.area_PreCredit=5;
            //               else if(n>=20)that.area_PreCredit=20;
            //               else if(n>=10)that.area_PreCredit=10;
            //               else that.area_PreCredit=8;
            //               }
            //             }
            //        }
            //  });
           
        },
        methods: {
          getAge(idCard) {
                const birthday = idCard.match(/\d{6}(\d{4})(\d{2})(\d{2})/);
              if (birthday) {
              const year = parseInt(birthday[1]);
              const month = parseInt(birthday[2]);
              const day = parseInt(birthday[3]);
               const today = new Date();
                 let age = today.getFullYear() - year;
               if (today.getMonth() < month - 1 || (today.getMonth() == month - 1 && today.getDate() < day)) {
                     age--;
                    }
              return age;
             } else {
               return -1; // 身份证号不合法
          }
         },
            getlenClass(len){
              if(len<2)return 'small';
              if(len<5)return 'small';
              else return 'big';
            },
            queryClick(flag){
              if(this.dataShow&&this.sxtype==flag){
                this.dataShow=false;
                return;
              }
              this.dataShow=true;
              this.sxtype=flag;
              if(this.caseResult[flag]>10)this.mlShow=true;
              else this.mlShow=false;
              this.pageIndex=1;
              this.sxdataList=this.getlistten(this.AllData[flag],1,10);
            },
            getlistten(list,pageIndex,pageSize){
              var newlist=[]
              for(var i=0;i<pageSize;i++){
                var j=i+(pageIndex-1)*pageSize;
                if(j<list.length)newlist.push(list[j]);
              }
              return newlist;
            },
            getCPCase(Code){
              let param1 = {
                    id:Code
                 }
                 var that=this;
              qccapis.getCPCase(param1).then(res => {
                if(res!=null){
                  that.sxdata=res;
                  for(var i=0;i<4;i++){
                  if(Number(res[i].Status)==200){
                    if(res[i].Result.VerifyResult==0)that.caseResult[i]=0;
                    else {
                      if(i<2)that.caseResult[i] = res[i].Paging.TotalRecords;
                      if(i==2)that.caseResult[i]=res[i].Result.Data.length;
                      if(i==3){
                        that.caseResult[i] = res[i].Paging.TotalRecords;
                       var datalist=res[3].Result.Data;
                        for(var j=0;j<datalist.length;j++){
                          var roletype="";
                          if(datalist[j].IsProsecutor)roletype="原告";
                          if(datalist[j].IsDefendant)roletype="被告";
                          datalist[j].RoleType=roletype;
                          var partylist=datalist[j].PartyList;
                          for(var k=0;k<partylist.length;k++){
                             if(partylist[k].RoleType==roletype){
                              datalist[j].Statement=partylist[k].Statement
                             }
                          }
                        }
                      }
                      that.AllData[i]=that.AllData[i].concat(res[i].Result.Data);
                      // if(!that.dataShow){
                      //      that.dataShow=true;
                      //      that.sxtype=i;
                      //      that.sxdataList=that.getlistten(res[i].Result.Data,1,10);
                      //      if(that.caseResult[i]>10)that.mlShow=true;
                      // }
                    }
                }else{
                  
                }
               }
              }else{
                that.$message.error("查询公司诉讼信息失败")
              }
             });

            },
            getList(flag){
              var type=this.sxtype;
              var that=this;
              var pageIndex=this.pageIndex+flag;
              if(pageIndex<1){that.$message.info("已经是第一页");return;}
              var allPage=(this.caseResult[this.sxtype]+9)/10;
              if(pageIndex>allPage){that.$message.info("已经是最后一页");return;};
              if(this.sxtype==2){
                this.pageIndex=pageIndex;
                this.sxdataList=this.getlistten(this.AllData[type],pageIndex,10);
              }else{
                let param1 = {
                    id:that.Code,
                    pageIndex:Math.ceil(pageIndex/2),
                    type:Number(type)+1
                 }
                 
                 qccapis.getCPCaseByType(param1).then(res => {
                if(res!=null){
                  if(Number(res.Status)==200){
                      var datalist=res.Result.Data;
                      if(type==3){
                        for(var j=0;j<datalist.length;j++){
                          var roletype="";
                          if(datalist[j].IsProsecutor)roletype="原告";
                          if(datalist[j].IsDefendant)roletype="被告";
                          datalist[j].RoleType=roletype;
                          var partylist=datalist[j].PartyList;
                          for(var k=0;k<partylist.length;k++){
                             if(partylist[k].RoleType==roletype){
                              datalist[j].Statement=partylist[k].Statement
                             }
                          }
                        }
                      }
                      var danwei=pageIndex%2;
                      if(danwei==0)danwei=2;
                      that.pageIndex=pageIndex;
                      var list=that.getlistten(res.Result.Data,danwei,10);
                      that.sxdataList=list;
                    }else{
                     that.$message.error(res[i].Message)
                    }
                  }else{
                   that.$message.error("查询信息失败")
                 }
                  });


              }
            },
            calcTableHeight() {
            this.$nextTick(() => {
                var height1 = $(".bg").height();
                // var height2 = $(".content-box .content .seach-container-new").height();
                // var height = height1 - height2 - 112 - 40;
                height1=(30+height1*0.03)+'px';
                this.FirstHeight = height1;
            });
        },
        }
};
</script>

<style>
  .atext {
          text-align: center;
            font-weight:bolder;
            letter-spacing: 2px;
      /* background: linear-gradient(to bottom, #ffffff, rgb(200,200,200)); 
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;  */
      text-shadow: 0px 1px 1px #fff
    }
            
    .bg{
        color: white;
         width:100%;
         background-image: url(../assets/img/credit/bg.png);
        background-size:cover;
       background-repeat:no-repeat;
    }
    .big3{
        margin-left: 10%;
        width:80%;
           background-image: url(../assets/img/credit/big.png);
      background-size:100% 100%;
       background-repeat:no-repeat;
    }
    .big{
        margin-left: 10%;
         width:80%;
           background-image: url(../assets/img/credit/big.png);
      background-size:100% 100%;
       background-repeat:no-repeat;
    }
       .small{
        margin-left: 10%;
         width:80%;
        background-image: url(../assets/img/credit/small.png);
        background-size:100% 100%;
       background-repeat:no-repeat;
      }
    .bg-title{
     color:white;
     margin-left: 10px;
     position: relative;
     top:-5px;
    }
    .bg-top{
        height: 30px;
        width: 6%;
        background-image: url(../assets/img/credit/top.png);
        background-size:100% 100%;
       background-repeat:no-repeat;
       margin-left: 9.25%;
       position: relative;
       top:-35px;
    }
    .bg-bottom{
        height: 30px;
        width: 4%;
        background-image: url(../assets/img/credit/bottom.png);
        background-size:100% 100%;
       background-repeat:no-repeat;
       margin-left: 83.1%;
       position: relative;
       top:-17px;
    }

    .el-input__inner {
        border: 0px;
    }
    .bg-content{
      margin: 0px 30px 0px 30px;
      padding-bottom: 30px;
    }
    .bg-content-text{
      margin: -10px 30px 0px 30px;
      padding-bottom: 30px;
      text-align: center;
    }
    .bg-table{
        border-collapse:collapse;
        width: 100%;
    }
    .bg-table tr td{
        height: 40px;
        line-height: 40px;
        padding-left: 10px;
    }
    .bg-table .title{
        width: 14%;
    }
    .bg-table .content{
        width: 11%;
    }



    .dialog-table{
        border-collapse:collapse;
        width: 100%;
    }
    .dialog-table tr td{
        height: 40px;
        line-height: 40px;
        /*text-indent: 10px;*/
        padding-left: 10px;
    }
    .dialog-table .title{
        background-color: rgb(242,249,252);
        width: 14%;
    }
    .dialog-table .content{
        width: 11%;
    }
    .label{
        font-weight: bold;
        margin-bottom: 10px;
    }
    .content{
        margin-left: 10%;
        width: 80%;
        margin-top: 20px;
    }
    .llTip{
        margin-top:30px;
        text-align: center;
        margin-bottom:30px;
    }
    @font-face {
      font-family: syht;
      src: url(../assets/思源黑体\ CN\ Normal.otf);
    }
</style>
